import { useTranslation } from "react-i18next";

import { Modal } from "#components/molecules/Modal/Modal";

type Props = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DiscardPartChangesConfirmationModal = ({ opened, onClose, onConfirm }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("quoteRequestV2.editPartModal.discardChangesTitle")}
      closeText={t("quoteRequestV2.editPartModal.cancel")}
      primaryText={t("quoteRequestV2.editPartModal.discardChangesConfirm")}
      primaryVariant="destructive"
      onPrimary={onConfirm}
    />
  );
};
